import { FC } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useLayoutContext } from 'contexts/LayoutContext';
import api from 'lib/trpcClient';
import AddEditBulletinUpdate from './AddEditBulletinUpdate';

type NewBulletinUpdateProps = {
  vehicleId: string;
};

const NewBulletinUpdate: FC<NewBulletinUpdateProps> = ({ vehicleId }) => {
  const [bulletinUpdate] = api.bulletinUpdate.getFormData.useSuspenseQuery({
    vehicleId,
  });

  return <AddEditBulletinUpdate bulletinUpdate={bulletinUpdate} />;
};

type CreatedBulletinUpdateProps = {
  vehicleId: string;
  bulletinUpdateId: string;
};

const CreatedBulletinUpdate: FC<CreatedBulletinUpdateProps> = ({
  vehicleId,
  bulletinUpdateId,
}) => {
  const [bulletinUpdate] = api.bulletinUpdate.getById.useSuspenseQuery({
    vehicleId,
    id: bulletinUpdateId,
  });

  return <AddEditBulletinUpdate bulletinUpdate={bulletinUpdate} />;
};

const AddBulletinUpdate: FC<NewBulletinUpdateProps> = ({ vehicleId }) => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const bulletinUpdateId = params.get('bulletinUpdateId');

  if (bulletinUpdateId) {
    return (
      <CreatedBulletinUpdate
        vehicleId={vehicleId}
        bulletinUpdateId={bulletinUpdateId}
      />
    );
  }

  return <NewBulletinUpdate vehicleId={vehicleId} />;
};

type EditBulletinUpdateProps = {
  vehicleId: string;
  id: string;
};

const EditBulletinUpdate: FC<EditBulletinUpdateProps> = ({ vehicleId, id }) => {
  const [bulletinUpdate] = api.bulletinUpdate.getById.useSuspenseQuery({
    vehicleId,
    id,
  });

  return <AddEditBulletinUpdate bulletinUpdate={bulletinUpdate} />;
};

const AddEditBulletinUpdateWrapper: FC = () => {
  const { id } = useParams<{ id?: string }>();
  const { selectedVehicleId } = useLayoutContext();
  const vehicleId = selectedVehicleId ?? '';

  if (id) {
    return <EditBulletinUpdate vehicleId={vehicleId} id={id} />;
  }

  return <AddBulletinUpdate vehicleId={vehicleId} />;
};

export default AddEditBulletinUpdateWrapper;
